import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import pt from "./locales/pt.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";

// Create complete resources object with fallbacks
const createResources = (locale: any) => ({
  home: locale.home || {},
  about: locale.about || {},
  skills: locale.skills || {},
  projects: locale.projects || {},
  research: locale.research || {},
  blog: locale.blog || {},
  testimonials: locale.testimonials || {},
  contact: locale.contact || {},
  common: locale.common || {},
  cronology: locale.cronology || {},
  footer: locale.footer || {},
  navigation: locale.navigation || {},
});

i18n
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetector)
  .init({
    fallbackLng: "en",
    lng: localStorage.getItem("i18nextLng") || "en", // Usa idioma do localStorage ou inglês como padrão
    ns: [
      "home",
      "about",
      "skills",
      "projects",
      "research",
      "blog",
      "testimonials",
      "contact",
      "common",
      "cronology",
      "footer",
      "navigation",
    ],
    defaultNS: "home",
    resources: {
      en: createResources(en),
      pt: createResources(pt),
      es: createResources(es),
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
